<div appAccessProvider [accessCode]="{ menuCode: 'SITES', pageCode: 'ALL', subPageCode: 'VIEW' }">
  <div class="mx-3">
    @if(allColumns.length > 0) {
    <app-mi-table
      class="w-full"
      [collectionOfColumns]="allColumns"
      [data]="tableData"
      [isLoading]="isLoading"
      (onPageChange)="onPageChange($event)"
      (itemPerPageChange)="itemPerPageChange($event)"
      (onSearchValueChange)="onSearchValueChanges($event)"
      [totalRecords]="totalRecords"
      [isEntity]="isEntity"
      [uniqueId]="uniqueId"
      [staticEntity]="'user'"
      (onSortData)="onSortData($event)"
      (onRowSelection)="onRowClick($event)">
    </app-mi-table>
    }
  </div>
</div>